export { AuthPagesLayout } from './AuthPagesLayout';
